// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-user-list {
  position: absolute;
  right: 0px;
  z-index: 9;
  top: 62px;
}

.chat-tab a.active .fa, .chat-tab a.active .pi {
  color: var(--listcolor) !important;
}

footer.chats {
  background: #eee !important;
}
footer.chats ::ng-deep .control.is-expanded:focus, footer.chats ::ng-deep .control.is-expanded:focus-within {
  box-shadow: none !important;
  border: none !important;
}
footer.chats .is-grouped:focus-within, footer.chats .is-grouped:focus {
  border-color: #b7b4b4 !important;
  box-shadow: none !important;
  min-height: 60px !important;
}
footer.chats .is-grouped {
  border-color: #b7b4b4;
  border-radius: 10px !important;
  min-height: 60px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/chat-list/chat-message/chat-message.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;AACJ;;AAGQ;EACK,kCAAA;AAAb;;AAIA;EACI,2BAAA;AADJ;AAEI;EACI,2BAAA;EACA,uBAAA;AAAR;AAEK;EACM,gCAAA;EACD,2BAAA;EACC,2BAAA;AAAX;AAEK;EACG,qBAAA;EACA,8BAAA;EACA,2BAAA;AAAR","sourcesContent":[".chat-user-list{\n    position: absolute;\n    right:0px;\n    z-index:9;\n    top:62px;\n}\n.chat-tab{\n    a.active{\n        .fa,.pi{\n             color:var(--listcolor) !important;\n        }\n    }\n}\nfooter.chats{\n    background: #eee !important;\n    ::ng-deep .control.is-expanded:focus,::ng-deep .control.is-expanded:focus-within{\n        box-shadow: none !important;\n        border: none !important;\n    }\n     .is-grouped:focus-within,.is-grouped:focus{\n           border-color: #b7b4b4 !important;\n          box-shadow: none !important;\n           min-height:60px !important;\n     }\n     .is-grouped{\n        border-color: #b7b4b4;\n        border-radius:10px !important;\n        min-height:60px !important;\n     }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
